export const ApiUrl = { apiUrl: "https://api.qrstand.gr" };



// WEBPACK FOOTER //
// ./src/apiUrl.js